import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import {
    gridNumberFormatter,
    formattedNumberValueGetter,
    csvDateHeaderValueGetter,
} from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, keyColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { MONTH_VIDEO_REPORT_ID } from './monthVideoReportId';

const monthReportColumnDefinition = [
    {
        headerName: FIELDS.DATE.label,
        headerValueGetter: FIELDS.DATE.headerValueGetter,
        headerComponentParams: FIELDS.DATE.headerComponentParams,
        field: FIELDS.DATE.field,
        type: [leftPinnedColumn, keyColumn],
        valueFormatter: FIELDS.DATE.valueFormatter,
        maxWidth: 180,
        csvValueGetter: FIELDS.DATE.csvValueGetter,
        csvHeaderValueGetter: csvDateHeaderValueGetter,
    },
    ...[
        FIELDS.SPENT,
        FIELDS.COMPLETED_VIEWS,
        FIELDS.VIDEO_IMPRESSIONS,
        FIELDS.VIDEO_VISIBLE_IMPRESSIONS,
        FIELDS.VIDEO_CPM,
        FIELDS.VIDEO_VCPM,
        FIELDS.CPCV,
        FIELDS.VIEWABILITY_RATE,
        FIELDS.HUNDRED_PCT_VIEWABILITY_RATE,
        FIELDS.COMPLETION_RATE,
        FIELDS.CLICKS,
        FIELDS.VIDEO_CTR,
        FIELDS.VIDEO_VCTR,
        FIELDS.CPA,
        FIELDS.VIDEO_CVR,
        FIELDS.CONVERSIONS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(monthReportColumnDefinition, MONTH_VIDEO_REPORT_ID);
